import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import GalleryImage from 'components/atoms/gallery-image'
import Checkbox from 'components/atoms/checkbox'
import { useMediaLayout } from 'use-media'
import { useTheme } from 'styled-components'

const StyledCheckbox = styled(Checkbox)`
  position: absolute;
  top: ${({ theme }) => theme.sizeByFactor(1.3)};
  left: ${({ theme }) => theme.sizings.lvl1};
  z-index: 10;
`

function SelectableGalleryImage({
  isSelected,
  onSelectChange,
  showCheckbox,
  carId,
  ...galleryImageProps
}) {
  const theme = useTheme()
  const isDesktop = useMediaLayout({ minWidth: theme.metrics.desktop })

  const handleCheckboxClick = (e) => e.stopPropagation()

  return (
    <>
      {showCheckbox && isDesktop && (
        <StyledCheckbox
          type="checkbox"
          name={carId}
          checked={isSelected}
          onClick={handleCheckboxClick}
          onChange={(checked) =>
            onSelectChange && onSelectChange(carId, checked)
          }
          aria-label="Select car"
        />
      )}
      <GalleryImage
        {...galleryImageProps}
        $withLabelOffset={showCheckbox && isDesktop}
      />
    </>
  )
}

SelectableGalleryImage.propTypes = {
  isSelected: PropTypes.bool,
  onSelectChange: PropTypes.func,
  showCheckbox: PropTypes.bool,
  carId: PropTypes.string,
}

export default SelectableGalleryImage
